export const helpCenterUrl = 'https://ayuda.fingo.cl/es-cl';
export const helpHowToFactoringUrl = 'https://ayuda.fingo.cl/es-cl/c%C3%B3mo-operar-factoring';
export const helpHowToOrderingUrl = 'https://ayuda.fingo.cl/es-cl/c%C3%B3mo-solicitar-financiamiento-de-ordenes-de-compra';
export const CREDENTIAL_PROVIDER_HELP_URL = 'https://ayuda.fingo.cl/es-cl/por-qu%C3%A9-tengo-que-ingresar-las-credenciales-del-facturador';
export const WHERE_TO_BUY_DIGITAL_CERTIFICATE_URL = 'https://www.autoriza.cl/store'
